
import {
  openNoAddressPop,
  formatWareImgUrl,
  noAddressCheck,
  getStockMax,
  getDeliveryMethod,
  priceFormatOther,
  customSkuKey
} from "../../utils/utils"
import { handleAddToCartV2 } from "../../utils/cartResponse"
import cardInputNumber from "@/components/cms/cardInputNumber.vue"
import emptyImg from "@/assets/images/empty_img.png"
import lazyImg from "@/components/cms/lazyImg.vue"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"
import { debounce } from "@/utils/utils"
import productSku from "@/components/drawer/productSku.vue"
import { getUserTrackingInfo } from "@/utils/userId"
import productCustomSku from "@/components/drawer/productCustomSku.vue"

export default {
  name: "CmsWare",
  components: {
    cardInputNumber,
    lazyImg,
    productSku,
    productCustomSku
  },
  props: {
    configData: {
      type: Object,
      default: () => {}
    },
    styleConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      skuVisible: false,
      customSkuVisible: false,
      configs: {},
      commonReqParams: {},
      deliveryMethod: "clickCollect",
      debounce: null
    }
  },
  computed: {
    // 是否支持定制
    customContentConfig() {
      return this.configs?.additional?.preferenceList?.find(item => item.preferenceKey === customSkuKey)
    },
    imageUrl() {
      const imgUrl = this.configs.spImgUrl
      if (imgUrl) {
        return formatWareImgUrl(imgUrl)
      }
      return emptyImg
    },
    detailLink() {
      const { skuId, sku, name, spuId } = this.configs?.additional || {}

      // Base URL
      let url = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?`

      // 1. 先添加 `skuId`（优先使用 `skuId`，否则用 `sku`）
      url += `skuId=${skuId || sku}`

      // 2. 再添加 `spuId`（如果存在）
      if (spuId) {
        url += `&spuId=${spuId}`
      }
      // 3. 最后添加 `name`（需要 `encodeURIComponent` 防止特殊字符破坏 URL）
      if (name) {
        url += `&name=${encodeURIComponent(name)}`
      }
      return url
    },
    findSimilarLink() {
      const { skuId, sku } = this.configs?.additional || {}
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${skuId || sku}`
    },
    /** 有广告文案时卡片需加高，否则固定 height 下底部价格会被裁切 */
    wareItemStyle() {
      const sc = this.styleConfig || {}
      const width = sc.width
      const height = sc.height
      if (!height) {
        return { width }
      }
      if (this.configs?.sellerId) {
        const m = /^([\d.]+)\s*rem$/i.exec(String(height).trim())
        if (m) {
          const extra = 0.22
          return { width, height: `${parseFloat(m[1], 10) + extra}rem` }
        }
      }
      return { width, height }
    }
  },
  watch: {
    configData: {
      handler(newVal) {
        // 聚合首页下发商品携带门店商家
        if (newVal?.venderId && newVal?.storeId) {
          newVal.additional.venderId = newVal.venderId
          newVal.additional.storeId = newVal.storeId
        }
        this.configs = newVal
        this.tagHideNo()
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    this.deliveryMethod = getDeliveryMethod()
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  mounted() {
    const sku = this.configs?.additional.sku || this.configs?.additional.skuId
    this.$bus.$off(`rest_${sku}_count`, this.handleRestCout)
    this.$bus.$on(`rest_${sku}_count`, this.handleRestCout)
    this.tagHideNo()
  },
  beforeDestroy() {
    const sku = this.configs?.additional.sku || this.configs?.additional.skuId
    this.$bus.$off(`rest_${sku}_count`, this.handleRestCout)
  },
  methods: {
    handleClose() {
      this.skuVisible = false
    },
    openSku() {
      this.skuVisible = true
    },
    openCustomSku() {
      this.customSkuVisible = true
    },
    handleRestCout(count) {
      this.$nextTick(() => {
        this.$set(this.configs, "addCartCount", count)
      })
    },
    async handleAddClick(item) {
      if (item.addCartCount > 0) {
        this.debounce = debounce(() => {
          this.debounce = null
        }, 3000)
        this.debounce()
        return
      }
      trackAddToCart(item)
      this.addcartTrack(item)
      const [error, data, wareList] = await handleAddToCartV2({
        // TODO storeId
        venderId: this.configs.venderId,
        storeId: this.configs.storeId || this.commonReqParams.storeId,
        wares: [{ sku: item.additional.sku || item.additional.skuId, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1
      })
      if (data) {
        const res = data
        this.$set(this.configs, "addCartCount", this.configs.addCartCount + 1)
        this.debounce = debounce(() => {
          this.debounce = null
        }, 3000)
        this.debounce()
        const sku = item.additional.sku || item.additional.skuId
        const Obj = wareList.find(item => item.sku === sku) || {}
        this.$set(this.configs, "stock", Obj.stock)
        // 同步相同sku商品加购数量
        // this.$bus.$emit(`rest_${sku}_count`, 1)
      } else {
        console.log("加购失败", error)
      }
    },
    addcartTrack(info) {
      if (info?.uclid) {
        const { userId, customLabel1 } = getUserTrackingInfo()
        const value = info?.matnr || info?.rfId
        const parmas = {
          cliUbid: userId,
          "f.custom_label_1": customLabel1,
          skuId: `SEHK-${value}`,
          productPrices: info?.additional?.promotionPrice
        }
        if (info?.sellerId) {
          parmas.sellerId = info?.sellerId
        } else {
          parmas.sellerId = -1
        }
        this.$onlineSalesSdk.registerAdd2CartEvent(parmas)
      }
    },
    handleNumChange(count, item) {
      handleChangeCartNumber(count, this.configs.addCartCount, item)
      const sku = item.additional.sku || item.additional.skuId
      const cocunt = count <= 0 ? 0 : count
      // 同步相同sku商品加购数量
      this.addcartTrack(item)
      this.$bus.$emit(`rest_${sku}_count`, cocunt)
      if (cocunt === 0) {
        this.debounce()
        this.debounce = null
      } else {
        this.debounce()
      }
    },
    goDetail(configs) {
      const { venderId, storeId } = configs
      if (venderId && storeId) {
        this.$cookies.set("store", storeId)
        this.$cookies.set("venderId", venderId)
      }
      this.trackSelectItem(configs)
    },
    trackSelectItem,
    getStockMax,
    priceFormatOther,
    handleComingSoonClick() {
      this.$message({
        type: "info",
        message: this.$t("common.comingSoon")
      })
    },
    tagHideNo() {
      this.$nextTick(() => {
        const container = this.$refs["span-container"]
        if (!container) return

        const containerWidth = container.offsetWidth
        const children = container.children

        // 重置所有子元素的样式类名
        for (let i = 0; i < children.length; i++) {
          children[i].classList.remove("ellipsis-tag")
          children[i].style.display = ""
        }

        // 计算累积宽度直到超出容器
        let accumulatedWidth = 0
        for (let i = 0; i < children.length; i++) {
          // 获取当前元素的宽度（包括 padding, border, margin）
          const elementWidth = children[i].offsetWidth

          // 获取前一个元素的 margin-right（如果不是第一个元素）
          let marginRight = 0
          if (i > 0) {
            const prevComputedStyle = window.getComputedStyle(children[i - 1])
            marginRight = parseFloat(prevComputedStyle.marginRight)
          }

          // 检查加上当前元素后是否会超出容器
          if (accumulatedWidth + marginRight + elementWidth > containerWidth) {
            // 对当前元素添加省略号样式类名
            children[i].classList.add("ellipsis-tag")

            // 隐藏后续的所有元素
            for (let j = i + 1; j < children.length; j++) {
              children[j].style.display = "none"
            }
            break
          }

          // 更新累积宽度
          accumulatedWidth += elementWidth + marginRight
        }
      })
    }
  }
}
